import { render, staticRenderFns } from "./deleteAffiliateCommission.vue?vue&type=template&id=7ad4aa82"
import script from "./deleteAffiliateCommission.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports